// src/SuccessIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var SuccessIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsxs("g", { stroke: "currentColor", children: [
      /* @__PURE__ */ jsx("path", { d: "M7.5 13.75a6.25 6.25 0 1 0 0 -12.5 6.25 6.25 0 0 0 0 12.5Z" }),
      /* @__PURE__ */ jsx("path", { d: "m5.313 7.813 1.25 1.25 3.125 -3.126" })
    ] })
  }
);
var SuccessIcon_default = SuccessIcon;

export {
  SuccessIcon_default
};
